//
import React from 'react';
import { StyleSheet, TextStyle, StyleProp, Text } from 'react-native';
import { TXT_GG } from '../../constants';
import colors from '../../colors';

type Props = {
  backgroundColor?: string;
  style?: StyleProp<TextStyle>;
};

const MiniInfo: React.FC<Props> = (props) => {
  const { children, style, backgroundColor } = props;
  return (
    <Text
      style={[styles.miniInfo, style, { backgroundColor: backgroundColor ?? colors.lightGrey }]}
    >
      {children}
    </Text>
  );
};

const styles = StyleSheet.create({
  miniInfo: {
    fontSize: 10,
    textAlign: 'center',
    alignSelf: 'center',
    includeFontPadding: false,
    color: '#fff',
    fontWeight: '700',
    padding: 5,
    borderRadius: 5
  }
});

export default MiniInfo;
